__turbopack_context__.v({
  "adminBorder": "c-x_Bq_adminBorder",
  "light": "c-x_Bq_light",
  "logoContainer": "c-x_Bq_logoContainer",
  "root": "c-x_Bq_root",
});
